<script lang="ts" setup>
import { dayjs } from 'element-plus'
import type { SearchObject } from './index'
import type { Dictionary } from '@/types/global'
const props = withDefaults(defineProps<{
  searchList?: Readonly<SearchObject[]>,
  hiddenReset?: boolean,
}>(), {
  searchList: () => [],
  hiddenReset: false,
})
const emits = defineEmits(['search', 'onReset', 'dateTimeRange', 'dayPicker'])
const form = ref<Dictionary>({})
props.searchList.forEach((item) => {
  if (item.value)
    form.value[item.key] = item.value
})

const firstSelectedDayRef = ref<Date | null>(null) // 记录选中的首个日期

function handleReset() {
  props.searchList.forEach((item) => {
    // 添加判断：日期-时间范围给默认值（设备详情-历史记录）  ||  日期范围给默认值（操作日志）
    if ((item.type === 'DAY_TIME_PICKER' && item.page === 'history') || (item.type === 'DATEPICKER' && item.page === 'operationLog'))
      form.value[item.key] = item.value
    else
      form.value[item.key] = undefined
  })

  emits('search', form.value, true)
}

function handleCalendarChange(date: Date[]) {
  const dymicDateItem = props.searchList.find(item => item.dymicDisabled)
  // 不需要动态配置日期范围
  if (!dymicDateItem) return

  const [minDate, maxDate] = date
  if (minDate && !maxDate)
    firstSelectedDayRef.value = minDate // 记录选中的首个日期
  else
    firstSelectedDayRef.value = null
}
function handleDymicDisabled(time: Date) {
  // 找到props中searchList中的dymicDisabled
  const dymicDateItem = props.searchList.find(item => item.dymicDisabled)
  const { dymicDisabled } = dymicDateItem || {}

  if (firstSelectedDayRef.value) {
    return dayjs(time).diff(dayjs(firstSelectedDayRef.value).subtract(dymicDisabled?.gap - 1, dymicDisabled?.unit)) < 0
      || dayjs(time).diff(dayjs(firstSelectedDayRef.value).add(dymicDisabled?.gap - 1, dymicDisabled?.unit)) > 0
  }
}

// 时间选择器的类型
// function datePickerType(type: string) {
//   switch (type) {
//     case 'DATEPICKER':
//       return 'daterange'
//     case 'DATETIMEPICKER':
//       return 'datetimerange'
//     case 'MONTHRANGEPICKER':
//       return 'monthrange'
//     case 'YEARPICKER':
//       return 'year'
//     case 'MONTHPICKER':
//       return 'month'
//     case 'DATE':
//       return 'date'
//     default:
//       return 'daterange'
//   }
// }

const dateType = ['DATEPICKER', 'DATETIMEPICKER', 'MONTHRANGEPICKER', 'YEARPICKER', 'MONTHPICKER', 'DATE']

// 日期时间范围选择器的change事件
function changeDateTimeRange(time: any) {
  console.log('changeDateTimeRange', time)
  emits('dateTimeRange', time)
}

// 在日历所选日期更改时触发
function calendarDayChange(time: any) {
  emits('dayPicker', time)
}

defineExpose({
  handleReset,
})

</script>

<template>
  <div class="search-box">
    <el-form :inline="true" @submit.prevent>
      <slot />
      <el-form-item v-for="(item, index) in searchList || []" :key="index" :label="`${item.label}：`">
        <el-select v-if="item.type === 'SELECT'" v-model="form[item.key]" placeholder="请选择" clearable remote-show-suffix
          v-bind="item" :filterable="item.filterable" :remote="item.remote" :remote-method="item.remoteMethod">
          <el-option v-for="option in item.options" :key="option.value" :value="option.value" :label="option.label" />
        </el-select>

        <el-date-picker v-else-if="item.type === 'DATE'" v-model="form[item.key]" type="date" style="width: 160px;"
          :clearable="!!item.clearable" :disabled-date="item.dymicDisabled ? handleDymicDisabled : item.disableData"
          @calendar-change="handleCalendarChange" />

        <el-date-picker v-else-if="item.type && dateType.includes(item.type)" v-model="form[item.key]"
          :type="item.type === 'DATETIMEPICKER' ? 'datetimerange' : 'daterange'" style="width: 300px;"
          start-placeholder="开始日期" end-placeholder="结束日期" :clearable="!!item.clearable"
          :disabled-date="item.dymicDisabled ? handleDymicDisabled : item.disableData" range-separator="至"
          :default-time="item.defaultValue" :editable="false" @calendar-change="handleCalendarChange" />
        <el-date-picker v-else-if="item.type === 'DAY_TIME_PICKER'" v-model="form[item.key]" type="datetimerange"
          style="width: 400px;" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
          :clearable="!!item.clearable" :disabled-date="item.disableData" @change="changeDateTimeRange" />
        <el-cascader v-else-if="item.type === 'CASCADER'" v-model="form[item.key]" :options="item.options" style="width: 400px;"
          :props="item.props ?? { label: 'name', value: 'id' }" clearable />

        <el-input v-else v-model="form[item.key]" :placeholder="item.placeholder || '请输入'" clearable
          @keyup.enter="$emit('search', form)" />
      </el-form-item>
      <el-form-item class="el-form-item--align">
        <el-button type="primary" @click="$emit('search', form)">
          查询
        </el-button>
        <el-button v-if="!hiddenReset" @click="handleReset">
          重置
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<style lang="scss">
.search-box {
  .el-form-item__content {
    .el-input__wrapper {
      width: 180px;
    }
  }
}
</style>
